module.exports = __webpack_public_path__ + "images/img-2Oe7AGV.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/postback-info/ru/2.png
// module id = 2327
// module chunks = 0